import { ComponentType } from 'react'
import { Toast as DSToast } from '@iveco-ti/iveco-ds'
import { ToastContentProps } from 'react-toastify'

type ToastProps = ToastContentProps<{
  type?: 'dark' | 'neutral' | 'success' | 'info' | 'warning' | 'danger'
  icon?: ComponentType
  title?: string
  description?: string
}>

export function Toast({ data, closeToast }: ToastProps) {
  const { type = 'neutral', title, description, icon: Icon } = data

  return (
    <DSToast.Root color={type} soft>
      {Icon && <DSToast.Icon icon={<Icon />} />}

      <DSToast.Body>
        {title && <DSToast.Title title={title} />}
        {description && <DSToast.Description description={description} />}
      </DSToast.Body>

      <DSToast.Close onClick={closeToast} />
    </DSToast.Root>
  )
}
